import React from "react";
import { Link } from "react-router-dom";
import "./About.css"; // Import the About.css file
import { FaArrowRight } from "react-icons/fa";

const About = () => (
    <div className="about-page">
        <h1>About</h1>
        <p>
        My Monday was born out of personal frustration with job search platforms like LinkedIn, Jobs.ch, and Indeed. Despite countless checkboxes and filters to sift through vast amounts of job ads, finding the right opportunity remained elusive. With My Monday, you can articulate what your dream job looks like, and from that, specific criteria and values are derived. Our AI then analyzes and scores each job ad according to your personalized criteria and values, making your job search more efficient and tailored to you. 
        <br/>
        <br/>
        Monday is the first working day of the week, make it your Monday, the Monday you want to go to work because you know you are working for an employer who shares your values.        </p>
        <br/>
        <a href="https://www.linkedin.com/in/tobiasstraumann/">Tobias Straumann</a>
        <br/>
        <br/>
        <Link to="/" className="sign-in-sign-up-button menu-style-button-2">
                From Dream to Job
              <FaArrowRight className="arrow" />
        </Link>
    
    </div>
    
);

export default About;